export const PERMISSIONS = {
  SCANNER: 'SCANNER',
  GET_REPORT: 'GET_REPORT',
  EVENT_REPORT: 'EVENT_REPORT',
  RESEND_EMAIL: 'RESEND_EMAIL',
  LIST_COUPON: 'LIST_COUPON',
  GET_COUPON: 'GET_COUPON',
  ADD_COUPON: 'ADD_COUPON',
  EDIT_COUPON: 'EDIT_COUPON',
  DELETE_COUPON: 'DELETE_COUPON',
  CREATE_ORDER: 'CREATE_ORDER',
  LIST_EVENTS: 'LIST_EVENTS',
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  COUPON_REPORT: 'COUPON_REPORT'
}

export const SCANNER_MATRIX_KEYS = [
  PERMISSIONS.SCANNER,
  PERMISSIONS.GET_REPORT,
  PERMISSIONS.EVENT_REPORT,
  PERMISSIONS.RESEND_EMAIL,
  PERMISSIONS.LIST_COUPON,
  PERMISSIONS.ADD_COUPON,
  PERMISSIONS.CREATE_ORDER
]

export const MATRIX_LABELS = {
  [PERMISSIONS.SCANNER]: 'Scan',
  [PERMISSIONS.GET_REPORT]: 'Reports',
  [PERMISSIONS.EVENT_REPORT]: 'Sales',
  [PERMISSIONS.RESEND_EMAIL]: 'Resend',
  [PERMISSIONS.LIST_COUPON]: 'Coupons',
  [PERMISSIONS.ADD_COUPON]: 'Add coupon',
  [PERMISSIONS.CREATE_ORDER]: 'Gate order'
}

export function isOrganiser(user) {
  const type = user?.eType || user?.eUserType || user?.sUserType
  return type === 'ORGANIZATION' || type === 'o' || type === 'ORGANISER'
}

export function getEventPermissionKeys(user, eventId) {
  if (!user || !eventId) return []
  if (isOrganiser(user)) return Object.values(PERMISSIONS)

  const match = (list = []) => list.find((item) => String(item?.iEventId) === String(eventId))

  const fromJwt = match(user.aEventPermissions)
  if (fromJwt?.aPermissions?.length) return fromJwt.aPermissions
  if (fromJwt?.aPermissionKeys?.length) return fromJwt.aPermissionKeys

  const fromProfile = match(user.aPermissions)
  if (fromProfile?.aPermissionKeys?.length) return fromProfile.aPermissionKeys
  if (fromProfile?.aPermissions?.length && typeof fromProfile.aPermissions[0] === 'string') {
    return fromProfile.aPermissions
  }

  return []
}

export function hasPermission(user, eventId, key) {
  if (isOrganiser(user)) return true
  const keys = getEventPermissionKeys(user, eventId)
  if (!key) return keys.length > 0
  if (Array.isArray(key)) return key.some((item) => keys.includes(item))
  return keys.includes(key)
}

export function hasLimitedAccess(user, eventId) {
  if (isOrganiser(user)) return false
  const keys = getEventPermissionKeys(user, eventId)
  return keys.length > 0 && keys.length < SCANNER_MATRIX_KEYS.length
}

export function canManageStaff(user) {
  return isOrganiser(user)
}
